import React from "react";
import styles from "./CancelButton.scss";
export interface ICancelButtonProps {
  onClick: any;
}

const CancelButton = (props: ICancelButtonProps) : JSX.Element => {
  const { onClick } = props;
  return (
    <button type="button" className={styles.button} onClick={onClick}>
      <span className={styles.text}>{"Nastavi bez isticanja"}</span>
    </button>
  );
};

export default CancelButton;



// WEBPACK FOOTER //
// ./src/containers/AdPromotePage/PromotionPackages/CancelButton/index.tsx